import styled from 'styled-components'

const ContentUi = styled.main`
  position: relative;
  ${({ $styles = {} }) => $styles}
`

export default ContentUi
